var React = require('react');

function Curations (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#626262","fillRule":"evenodd"},[React.createElement("path",{"d":"M22 0v22H0V0h22zM2 20h18V2H2v18z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M11.42 16.21c3.08 0 4.397-2.1 4.719-3.472l-2.114-.602c-.196.714-.882 1.862-2.604 1.862-1.484 0-2.856-1.078-2.856-2.94 0-2.086 1.498-3.038 2.828-3.038 1.75 0 2.38 1.162 2.534 1.848l2.086-.658c-.322-1.428-1.638-3.346-4.62-3.346-2.772 0-5.124 2.1-5.124 5.194s2.296 5.152 5.152 5.152z","key":1})]));
}

Curations.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Curations;

Curations.default = Curations;
